import React, { FC } from 'react'
import classnames from 'classnames'
import { Button2 } from '../../../Button2/Button2'
import style from './SendCodeSingleButton.module.css'

type SendCodeSingleButtonProps = {
  text: string
  timeout: number
  onMouseDown(): void
}

export const SendCodeSingleButton: FC<SendCodeSingleButtonProps> = ({ text, timeout, onMouseDown }) => {
  const classNames = classnames(style.sendCodeSingleButton, {
    [style.timeout]: timeout,
  })

  return (
    <Button2 className={classNames} onMouseDown={onMouseDown} isDisabled={Boolean(timeout)}>
      {text}
    </Button2>
  )
}

SendCodeSingleButton.displayName = 'SendCodeSingleButton'
